module.exports = __webpack_public_path__ + "img/problem_broken_toilet.808af1c3.svg";